<template>
  <article class="performer-message-item">
    <loading v-if="displayProgress" />
    <message-modal
      v-if="isOpenMessageModal"
      @onClickBg="closeMessageModal"
    >
      <div class="message-detail-modal-inner">
        <div class="title-wrapper">
          <div class="performer-message-item-info-modal-title-img-wrap">
            <img
              :src="setCurationImg(imgUrl)"
              :alt="title"
              class="pg-performer-events--modal-img-little-wrap"
            />
            <div class="performer-message-item-info-title-wrap">
              <h5 class="title">
                {{ title }}
              </h5>
              <p class="date">
                {{ date }}
              </p>
              <a :href="topPageUrl" target="_blank" rel="external nofollow noopener">
                <p class="curation_media">
                  {{ curationMedia }}
                </p>
              </a>
              <p class="description only-pc">
                {{ description }}
              </p>
              <a class="more_read_wrap only-pc" :href="siteUrl" target="_blank" rel="external nofollow noopener">
                <button class="more_read only-pc">
                  続きを読む
                </button>
              </a>
            </div>
          </div>
          <p class="description only-sp">
            {{ description }}
          </p>
          <a class="more_read_wrap only-sp" :href="siteUrl" target="_blank" rel="external nofollow noopener">
            <button class="more_read only-sp">
              続きを読む
            </button>
          </a>
          <div class="assets-wrapper">
            <p class="good">
              {{ articleGoodsCount }}
            </p>
            <p class="comment">
              {{ messagesCommentsCount }}
            </p>
          </div>
        </div>
        <div class="content-wrapper">
          <div class="iframe-wrapper">
          </div>
          <div class="action-btns-wrapper">
            <button
              v-if="!isArticleGood"
              class="good-btn"
              @click="goodToMessage"
              :disabled="isSendingRequest"
            >
              <img :src="require('assets/images/curation/good.svg')"  width="20" height="17">
            </button>
            <button
              v-else type="button"
              class="good-btn"
              @click="deleteGoodToMessage"
              :disabled="isSendingRequest"
            >
              <img :src="require('assets/images/curation/gooded.svg')"  width="20" height="17">
            </button>
            <button type="button" class="comment-btn" @click="toggleCommentModal">コメントする</button>
          </div>
        </div>
        <div class="comment-list-wrapper">
          <p class="sub-title">
            コメント
          </p>
          <div class="comment-list-inner">
            <template v-if="messagesComments.length !== 0">
              <div
                class="comment-item"
                v-for="comment in messagesComments"
                :key="comment.id"
              >
                <p class="comment-item-poster">
                  {{ comment.user }}
                </p>
                <p class="comment-item-content">
                  {{ comment.text }}
                </p>
              </div>
            </template>
            <template v-else>
              この記事にはまだコメントがありません
            </template>
          </div>
        </div>
      </div>
    </message-modal>
    <message-comment-modal
      v-if="isOpenMessageCommentModal"
      @onClickBg="closeMessageCommentModal"
    >
      <div class="message-comment-modal-inner">
        <div class="comment-input-wrapper">
          <p class="sub-title">
            コメント
          </p>
          <textarea
            v-model="comment"
          />
        </div>
        <p class="caution">
          ・コメントするとTIGET会員登録のプロフィールの名前が表示されます。<span class="link" @click="onClickProfile">プロフィールの変更</span>はこちら<br>
          ・コメントが主催者または管理者によって不適切と判断されると、削除される場合がございます。ご了承ください。<br>
          ・コメントを投稿する際には、<span class="link" @click="onClickPolicy">利用規約・特約</span>を順守し、内容に責任をもってご投稿ください。
        </p>
        <div class="action-btns-wrapper">
          <button type="button" class="comment" @click="postComment" :disabled="isSendingRequest">コメントする</button>
          <button type="button" class="cancel" @click="closeMessageCommentModal">キャンセル</button>
        </div>
      </div>
    </message-comment-modal>
    <div class="performer-message-item-info">
      <div class="performer-message-item-info-title-img-wrap">
        <img
          :src="setCurationImg(imgUrl)"
          :alt="title"
          class="pg-performer-events--img-little-wrap"
          @click="toggleMessageModal"
        />
        <div class="performer-message-item-info-title-wrap">
          <h3
            class="performer-message-item-info-title"
            @click="toggleMessageModal"
          >
            {{ title }}
          </h3>
          <p
            class="performer-message-item-info-date"
            @click="toggleMessageModal"
          >
            {{ date }}
          </p>
          <a :href="topPageUrl" target="_blank" rel="external nofollow noopener">
            <p class="performer-message-item-info-curation_media">
              {{ curationMedia }}
            </p>
          </a>
        </div>
      </div>
      <div class="assets-wrapper">
        <p class="good">
          {{ articleGoodsCount }}
        </p>
        <p class="comment">
          {{ articleCommentsCount }}
        </p>
      </div>
    </div>
  </article>
</template>

<script>
// components
import MessageModal from './MessageModal.vue'
import MessageCommentModal from './MessageModal.vue'
import Loading from './CurationLoading.vue'

export default {
  components: {
    MessageModal,
    MessageCommentModal,
    Loading
  },
  props: {
    id: {
      type: Number
    },
    title: {
      type: String
    },
    date: {
      type: String
    },
    description: {
      type: String
    },
    imgUrl: {
      type: String,
      default: require('assets/images/curation/no_image.svg')
    },
    curationMedia: {
      type: String
    },
    topPageUrl: {
      type: String
    },
    favCount: {
      type: Number
    },
    commentsCount: {
      type: Number
    },
    siteUrl: {
      type: String
    },
    isGood: {
      type: Boolean
    },
    isSignedIn: {
      type: Boolean
    },
    articleCommentsAPIPath: {
      type: String
    },
    artilceGoodsPath: {
      type: String
    }
  },
  data () {
    return {
      comment: '',
      articleGoodsCount: 0,
      articleCommentsCount: 0,
      page: 1,
      isOpenMessageModal: false,
      isOpenMessageCommentModal: false,
      isArticleGood: false
    }
  },
  created () {
    this.articleGoodsCount = this.favCount
    this.articleCommentsCount = this.commentsCount
    this.isArticleGood = this.isGood
  },
  computed:{
    messagesComments: function () {
      return this.$store.getters['curationSiteArticle/articleComments']
    },
    messagesCommentsCount: function () {
      return this.$store.getters['curationSiteArticle/articleCommentsCount']
    },
    messagesGoodsCount: function () {
      return this.$store.getters['curationSiteArticle/articleGoodsCount']
    },
    httpSuccess: function () {
      return this.$store.getters['curationSiteArticle/httpSuccess']
    },
    articleGood: function () {
      return this.$store.getters['curationSiteArticle/articleGood']
    },
    displayProgress: function () {
      return this.$store.getters['curationSiteArticle/displayProgress']
    },
    isSendingRequest: function () {
      return this.$store.getters['curationSiteArticle/isSendingRequest']
    }
  },
  methods: {
    onClickProfile: function () {
      this.$emit('onClickProfile')
    },
    onClickPolicy: function () {
      this.$emit('onClickPolicy')
    },
    getMessagesComments: function () {
      return this.$store.dispatch('curationSiteArticle/getArticleComments', {api_path: this.articleCommentsAPIPath, p: this.id, page: this.page, per:10})
    },
    postMessagesComments: function () {
      return this.$store.dispatch('curationSiteArticle/postArticleComments', {api_path: this.articleCommentsAPIPath, p: this.id, payload: {body: this.comment} })
    },
    postMessagesGoods: function () {
      return this.$store.dispatch('curationSiteArticle/postArticleGoods', {api_path: this.artilceGoodsPath, p: this.id })
    },
    deleteMessagesGoods: function () {
      return this.$store.dispatch('curationSiteArticle/deleteArticleGoods', {api_path: this.artilceGoodsPath, p: this.id })
    },
    async toggleMessageModal () {
      await this.getMessagesComments()
      this.isOpenMessageModal = !this.isOpenMessageModal
      if (this.isOpenMessageModal) {
        document.body.setAttribute('style', 'overflow: hidden;')
      } else {
        document.body.removeAttribute('style', 'overflow: hidden;')
      }
    },
    async postComment () {
      await this.postMessagesComments()
      if (this.httpSuccess) {
        await this.getMessagesComments()
        this.articleCommentsCount = this.messagesCommentsCount
        this.isOpenMessageCommentModal = !this.isOpenMessageCommentModal
        this.isOpenMessageModal = !this.isOpenMessageModal
      }
    },
    closeMessageModal: function () {
      this.isOpenMessageModal = false
      document.body.removeAttribute('style', 'overflow: hidden;')
    },
    toggleCommentModal: function () {
      if (this.isSignedIn) {
        this.isOpenMessageModal = !this.isOpenMessageModal
        this.isOpenMessageCommentModal = !this.isOpenMessageCommentModal
      } else {
        this.closeMessageModal()
        this.$emit('toggleSignUpModal')
      }
    },
    closeMessageCommentModal: function () {
      this.isOpenMessageCommentModal = false
      this.closeMessageModal()
    },
    async goodToMessage () {
      if (this.isSignedIn) {
        await this.postMessagesGoods()
        this.articleGoodsCount = this.messagesGoodsCount
        this.isArticleGood = this.articleGood
      } else {
        this.closeMessageModal()
        this.$emit('toggleSignUpModal')
      }
    },
    async deleteGoodToMessage () {
      if (this.isSignedIn) {
        await this.deleteMessagesGoods()
        this.articleGoodsCount = this.messagesGoodsCount
        this.isArticleGood = this.articleGood
      } else {
        this.closeMessageModal()
        this.$emit('toggleSignUpModal')
      }
    },
    setCurationImg: function (imgURL) {
      if (imgURL != null && imgURL != ''){
        return imgURL;
      }
      return require('assets/images/curation/no_image.svg');
    }
  }
}
</script>

<style lang="scss" scoped>
$breakpoint: 767px;

  .performer-message-item {
      button {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;
        border: none;
        cursor: pointer;
        outline: none;
        padding: 0;
        appearance: none;
        border-radius: 4px;
        border: 1px solid #c8c8c8;

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
      .assets-wrapper {
        display: flex;
        align-items: center;
        p {
          display: flex;
          align-items: center;
          font-size: 13px;

          &:before {
            content: '';
            display: inline-block;
            background-repeat: no-repeat;
            background-size: cover;
            width: 16px;
            height: 14px;
            margin-right: 5px;
          }

          &.good {
            color: #f05064;
            margin-right: 10px;

            &:before {
              background-image: url(../../assets/images/curation/goods.svg);
            }
          }
          &.comment {
            color: #999;

            &:before {
              background-image: url(../../assets/images/curation/comment.svg);
            }
          }
        }
      }

    &-info {
      &-title {
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
        transition: .2s;

        &:hover {
          opacity: 0.7;
        }

        @media screen and (max-width: $breakpoint) {
          display: -webkit-box;
          overflow: hidden;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      &-date {
        font-size: 13px;
        color: #666;
        margin-bottom: 2px;
      }

      &-curation_media {
        font-size: 13px;
        color: #666;
        margin-bottom: 15px;
      }
    }

    .message-detail-modal-inner {
      .title-wrapper {
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 20px;

        .title {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 15px;
        }

        .date {
          color: #666;
          font-size: 14px;
          margin-bottom: 2px;
        }

        .curation_media {
          font-size: 13px;
          color: #666;
          margin-bottom: 5px;
        }

        .description {
          &.only-pc {
            display: block;
            @media screen and (max-width: $breakpoint) {
              display: none;
            }
          }
          &.only-sp {
            display: none;
            @media screen and (max-width: $breakpoint) {
              display: block;
            }
          }
        }

        .more_read_wrap {
          display: block;
          text-align: center;
          margin-top: 20px;

          &.only-pc {
            display: block;
            @media screen and (max-width: $breakpoint) {
              display: none;
            }
          }
          &.only-sp {
            display: none;
            @media screen and (max-width: $breakpoint) {
              display: block;
            }
          }

          .more_read {
            display: inline-block;
            border: 1px solid #c8c8c8;
            border-radius: 4px;
            color: #666;
            font-size: 13px;
            width: 160px;
            height: 38px;
            -webkit-transition: .2s;
            transition: .2s;

            &.only-pc {
              display: inline-block;
              @media screen and (max-width: $breakpoint) {
                display: none;
              }
            }
            &.only-sp {
              display: none;
              @media screen and (max-width: $breakpoint) {
                display: inline-block;
              }
            }
          }
        }

      }
      .content-wrapper {
        margin-bottom: 40px;

        @media screen and (max-width: $breakpoint) {
          margin-bottom: 30px;
        }

        .iframe-wrapper {
          margin-bottom: 20px;
          max-width: 800px;
          width: 100%;

          @media screen and (max-width: $breakpoint) {
            margin-bottom: 30px;
          }

          iframe {
            width: 100%;
            height: 100%;
          }
        }

        .action-btns-wrapper {
          display: flex;
          flex-direction: row;

          .good-btn {
            width: 50px;
            height: 38px;
            margin-right: 10px;
          }

          .comment-btn {
            width: 140px;
            height: 38px;
            color: #666;
          }
        }
      }
      .comment-list-wrapper {
        .sub-title {
          color: #666;
          font-size: 13px;
          font-weight: bold;
          margin-bottom: 10px;
        }

        .comment-list-inner {
          background-color: #f7f7f7;
          padding: 20px;

          @media screen and (max-width: $breakpoint) {
            width: calc(100% + 40px);
            margin-left: -20px;
            padding: 20px  20px 100px 20px;
          }

          .comment-item {
            margin-bottom: 15px;

            &-poster {
              color: #999;
              font-size: 12px;
              font-weight: bold;
              margin-bottom: 10px;
            }
          }
        }
      }
    }

    .message-comment-modal-inner {
      .comment-input-wrapper {
        margin-bottom: 30px;

        @media screen and (max-width: $breakpoint) {
          margin-bottom: 20px;
        }

        .sub-title {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 20px;
        }

        textarea {
          appearance: none;
          resize: none;
          padding: 15px;
          border: 1px solid #e6e6e6;
          outline: none;
          background-color: #f7f7f7;
          width: 100%;
          height: 200px;
        }
      }

      .caution {
        margin-bottom: 30px;

        .link {
          cursor: pointer;
          color: #3399cc;
        }
      }

      .action-btns-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;

        .comment,
        .cancel {
            width: 140px;
            height: 38px;
        }

        .comment {
          color: #fff;
          background-color: #000;
          border: none;
          margin-bottom: 20px;
        }

        .cancel {
          color: #666;
        }
      }
    }

    .performer-message-item-info-title-img-wrap {
      display: flex;
    }

    .performer-message-item-info-modal-title-img-wrap {
      display: flex;
    }

    .performer-message-item-info-title {
      color: #333;
      text-align: left;
      padding-bottom: 0;
    }

    .pg-performer-events--img-little-wrap {
      height: 130px;
      width: 130px;
      min-width: 130px;
      object-fit: cover;
      margin: 0 10px 10px 0;

      @media screen and (max-width: $breakpoint) {
        width: 80px;
        height: 80px;
        min-width: 80px;
      }

    }

    .pg-performer-events--modal-img-little-wrap {
      @extend .pg-performer-events--img-little-wrap;

      @media screen and (max-width: $breakpoint) {
        width: 130px;
        height: 130px;
        min-width: 130px;
      }
    }
  }
</style>
